import React from "react";

const defaultPackageData = [
  {
    indicateproduct: "",
    reclaimedproduct: "",
  },
];

const ReclaimedPackagingTable = ({ packagedata, setPackageData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...packagedata];
    updated[index][field] = value;
    setPackageData(updated);
  };

  const addRow = () => {
    setPackageData([...packagedata, { category: "", percentage: "" }]);
  };

  const removeRow = (index) => {
    const updated = [...packagedata];
    updated.splice(index, 1);
    setPackageData(updated);
  };

  return (
    <div>
      <div
        style={{
          marginTop: "20px",
          overflowX: "auto",
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
              <th style={tableHeaderStyle}>Indicate product category</th>
              <th style={tableHeaderStyle}>
                Reclaimed products and their packaging materials as % of total
                products sold in respective category
              </th>
            </tr>
          </thead>
          <tbody>
            {packagedata.map((row, index) => (
              <tr key={index}>
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    placeholder="Write the category"
                    value={row.category}
                    onChange={(e) =>
                      handleChange(index, "category", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    placeholder="Percentage"
                    value={row.percentage}
                    onChange={(e) =>
                      handleChange(index, "percentage", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          marginTop: "10px",
        }}
      >
        <button onClick={addRow} style={addButtonStyle}>
          + Add Row
        </button>
        {packagedata.length > 1 && (
          <button
            onClick={() => removeRow(packagedata.length - 1)}
            style={removeButtonStyle}
          >
            - Remove
          </button>
        )}
      </div>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "16px", // more vertical space
  border: "1px solid #000",
  textAlign: "center",
  verticalAlign: "middle", // center align text vertically
};

const inputStyle = {
  width: "100%",
  padding: "30px", // increased vertical padding
  minHeight: "30px", // taller input box
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  textAlign: "center",
  outline: "none",
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};
export default ReclaimedPackagingTable;
